import { ModelBase } from 'store/model-base';

export class CmsE911Address extends ModelBase {
    public static storeName: string = 'cmsE911Address';

    public address: CmsAddressFields;
    public manageAddress: CmsE911AddAddress;
    public verifyAddress: CmsE911VerifyAddress;
    public savedAddress: CmsE911SavedAddress;
    public welcomeBack: CmsE911WelcomeBack;
    public errors: CmsE911Error[];
}
